<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  components: {},
  // async beforeCreate() {
  //   if (this.$route.path !== "/login") {
  //     await this.$store.dispatch("GetUserInfo");
  //   }
  // },
};
</script>

<style style="scss">
#app {
}
/* .el-table {
  font-size: 12px;
  width: 99.9%;
} */
</style>
